__turbopack_context__.v({
  "button": "BackToTop-module__bBep8G__button",
  "fadeIn": "BackToTop-module__bBep8G__fadeIn",
});
